import React from "react";
import { useTranslation } from 'react-i18next';
import Close from '@material-ui/icons/Close';
import { ReadOnly } from './style';

type SubMenuItems = {
    handleClose: () => void;
    rolEvent: rolEvent;
};

type rolEvent = {
    rolEventTarget: string,
    rolEventType: string,
    rolEventSource: string,
}


export const ReadOnlyComp = (props:SubMenuItems ) => {
    const { handleClose } = props;
    const { rolEvent } = props;
    const { t } = useTranslation();

    console.log("rolEvent: ", rolEvent);
    window.wb_track('ROL_EVENT', rolEvent);
    return (
        <ReadOnly>
          <h3>{t('Just Looking')} 👀</h3>
          <Close style={{ cursor:'pointer', marginTop: '4px', width:'24px', height:'24px' }} onClick={handleClose} />
          <p>{t('You\'re currently in "view only" mode! If you want to jump in and start creating, commenting, and interacting with Objectives, Key Results, Scorecards, Workstreams, and Issues, you’ll need an upgrade.')}</p>
          <p style={{ paddingTop: '8px' }}>{t('Chat with your manager to make it happen.')}</p>
        </ReadOnly>
    )
}
